import React, { useEffect, useMemo, useState } from 'react';
import { Element } from 'react-scroll';
import MaterialTable from 'material-table';
import { Form } from 'react-bootstrap';
import BackBtn from '../../../components/UI/BackBtn';
import { styledTable } from '../../../helpers';
import useAPI from '../../../hooks/useAPI';
import useUserContext from '../../../hooks/useUserContext';
import useToast from '../../../hooks/useToast';
import TooltippedElement from '../../../components/common/TooltippedElement';
import StatusBadge from '../../../components/common/StatusBadge';
import { modifyDefaultOptions, objectToCols } from '../../../helpers/table';
import { closeYearForType, getPeriodsData } from '../../../requests/exportRequests';
import style from './style.module.less';
import {useParams} from "react-router-dom";
import useNavProject from "../../../hooks/useNavProject";
import {Tab, Tabs} from "../../../components/Tabs";
import ReportRegisterTab from "../../../components/SPReportTabs/ReportRegisterTab";
import PassportYearsTab from "./Tabs/PassportYearsTab";
import KpiYearsTab from "./Tabs/KpiYearsTab";
import BaseYearsTabs from "./Tabs/BaseYearsTabs";

const styledHeading = {
  marginLeft: 0, marginBottom: 24, marginTop: 24, color: 'rgba(0, 0, 0, 0.87)',
};

const tabs = [
    {
        label: 'passportSettings',
        tabName: 'Управление доступом к ЦП',
        tabType: 'passport',
        tabHeader: 'Управление доступом к редактированию планов в цифровых паспортах проектов (уникальные результаты, показатели, бюджет)'
    },

    {
        label: 'kpiSettings',
        tabName: 'Управление доступом к показателям',
        tabType: 'kpi',
        tabHeader: 'Управление доступом к редактированию показателей'
    },
    {
        label: 'resultsSetting',
        tabName: 'Управление доступом к выдающимся результатам СП',
        tabType: 'results',
        tabHeader: 'Управление доступом к заполнению планов по выдающимся результатам стратегических проектов'
    },
    {
        label: 'periodSettings',
        tabName: 'Администрирование отчетного периода',
        tabType: 'periodFields',
        tabHeader: 'Контроль обновления фактических значений показателей в разделах «Целевые показатели эффективности (базовая и специальная части гранта), показатели достижения результата (столбец "Факт на последнюю отчетную дату")'
    },
]

function AdminSettings() {
    // const { stratId } = useParams();
    //
    // const [project, setProject] = useState(null);
    //
    // const navProject = useNavProject();
    // const api = useAPI();
    //
    // useEffect(async() => {
    //     const result = await api.get(`/mng/strategies/${stratId}`);
    //     navProject.setStratTitle(result.name);
    //     setProject(result);
    // }, [])

    return (
        <section className='page project-page'>
            <div className='container'>
                <div style={{marginBottom: 16}}>
                    <BackBtn/>
                </div>
                <Tabs>
                    {tabs
                        //.filter(tab => !tab.hide || !tab.hide(userCtx.perms))
                        .map((tab, i)=>
                            <Tab key={i} label={tab.label} tabName={tab.tabName}>
                                <BaseYearsTabs type={tab.tabType} header={tab.tabHeader}/>
                            </Tab>
                        )
                    }
                </Tabs>
            </div>
        </section>
    );
}

export default AdminSettings;
